import React, { Fragment, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { translate } from '../Services/translation';
import { query, searchFacetChange } from '../Actions/FacetedSearch.action';
import { filterType } from '../Models/FilterConstants';
import RangeSlider from "../Components/RangeSlider";
import Checkbox from './Checkbox';
import wNumb from 'wnumb';

const FacetedSearchGroup = (props) => { 
    const dispatch = useDispatch();
    const listRef = useRef("list");   
    let collapsedInfo = props.index > 1;
    if (window.location.href.indexOf(props.group.id) > -1) {
        collapsedInfo = false;
    }
    const [collapsed, setcollapsed] = useState(collapsedInfo);
    const [showLessItemCount, setshowLessItemCount] = useState(false);

    const toggleGroup = (prevState) => {
        setcollapsed(!prevState);
    }

    const { group } = props;
    return (
        <Fragment>
            {group.options && group.options.length > 0 && group.filterType === filterType.slider && group.options[0].maxValue != 0 &&
                <a className={'faceted-search__group-header' + (collapsed ? ' faceted-search__group-header--collapsed' : '')} onClick={() => toggleGroup(collapsed)}>
                    {group.label}
                    <svg>
                        <use href="/ui/images/tibergs-svg/sprite/sprite.svg#arrow-right"></use>
                    </svg>
                </a>}
            {group.options && group.options.length > 0 && group.filterType != filterType.slider &&
                <a className={'faceted-search__group-header' + (collapsed ? ' faceted-search__group-header--collapsed' : '')} onClick={() => toggleGroup(collapsed)}>
                    {group.label}
                    <svg>
                        <use href="/ui/images/tibergs-svg/sprite/sprite.svg#arrow-right"></use>
                    </svg>
                </a>
            }
            {group.filterType === filterType.slider && group.options.length > 0 ?
                group.options[0].maxValue != 0 ?
                    <div className="faceted-search__range-group">
                        <div className="faceted-filter__label noUi-range-label">{group.label}</div>
                        <RangeSlider
                            id={group.id}
                            group={group}
                            value={group.selectedOptions != undefined ? ([group.selectedOptions.toString().split("-")[0], group.selectedOptions.toString().split("-")[1]]) : []}                            
                            range={{ min: 0, max: group.options[0].maxValue }}
                            start={[0, group.options[0].maxValue]}
                            connect={true}
                            format={wNumb({
                                decimals: 0,
                                thousand: ' ',
                                suffix: group.options[0].suffix
                            })}
                            step={group.options[0].step}
                            key={Date.now()}
                        />
                    </div> : null
                : (group.options && group.options.length > 0 &&
                    <ul className="faceted-search__group">
                        {group.options && group.options.map((item, itemIndex, array) => (
                            <li key={`${item.label}-${itemIndex}`} className="faceted-search__item" 
                            /*ref={itemIndex === showLessItemCount - 1 ? "showLess" : itemIndex === array.length - 1 ? "showMore" : null}*/>
                                <FacetedFilterCheckbox item={item} group={group} searchFacetChange={() => dispatch(searchFacetChange())} />
                            </li>
                        ))}
                    </ul>
                )
            }
        </Fragment>
    )
};

const FacetedSearch = () =>  {
    const dispatch = useDispatch();
    const facetedSearch = useSelector((state) => state.facetedSearch);
    return (facetedSearch.navigationTheme !== 'category' && <div className="faceted-search">
        {facetedSearch.facetFilters && facetedSearch.facetFilters.map((group, groupIndex, array) => (
            group !== null && <FacetedSearchGroup key={`${group.label}-${groupIndex}`} group={group} index={groupIndex} 
            searchFacetChange={() => dispatch(searchFacetChange(group, item))} />
        ))}
    </div>)
}

const FacetedFilterCheckbox = ({ item, group, searchFacetChange }) => {
    const dispatch = useDispatch();
   return (<div className="faceted-filter">
        <Checkbox isChecked={group.selectedOptions != null && group.selectedOptions.includes(item.id)}
        isSmall={false} value={null} group={group} item={item} isSearch={true}></Checkbox>
        <a className="faceted-filter__label" onClick={() => dispatch(searchFacetChange(group, item))}>
            {item.label}
            {!isNaN(item.quantity) && (item.quantity != null) &&
                <span className="faceted-filter__quantity">&nbsp;({item.quantity})</span>
            }
        </a>
    </div>)
};

export default FacetedSearch;
